const AppTabsSection = () => {
  return (
    <section className="flex flex-row items-center justify-center gap-10 px-10" data-cy="app-tabs-section">
      <div className="h-96 w-full rounded-2xl bg-sandstone-500" />
      <div className="h-96 w-full rounded-2xl bg-sandstone-500" />
      <div className="h-96 w-full rounded-2xl bg-sandstone-500" />
    </section>
  );
};

export default AppTabsSection;
